export default "__VITE_ASSET__BMkwX$ve__"